export const SEARCH_FILTER_SHOW_STATUS = {
  ALL: 'all',
  MY: 'my',
  SP: 'sp',
} as const;

export type SearchFilterShowStatus = (typeof SEARCH_FILTER_SHOW_STATUS)[keyof typeof SEARCH_FILTER_SHOW_STATUS];
